export const error = state => state.error
export const isLoading = state => state.isLoading
export const retrieved = state => state.retrieved
export const invoiceAdapter = function (state) {
  let order = {}
  if (state.retrieved) {
    order.invoiceDocumentType = state.retrieved.invoiceDocumentType
    order.idInvoice = state.retrieved['@id']
    order.firm = state.retrieved.firm
    order.positions = state.retrieved.invoicePositions
    order.valueBrutto = state.retrieved.totalValueBrutto
    order.valueNetto = state.retrieved.totalValueNetto
  }
  return order
}
